import { APIURL } from "../models/api-base";
import { apiUrl_popups } from "../models/api-urls";
import fetchService from "../modules/APIService";

class Service extends fetchService {
    constructor() {
        super(APIURL);
    }

    getAllPopups = async () => {
        const endpoint = apiUrl_popups;
        console.log("Fetching popups from:", endpoint);
        const response = await this.get(endpoint);
        return response;
    };

    createPopup = async (data) => {
        const endpoint = apiUrl_popups;
        const response = await this.post(`${endpoint}`, data);
        return response;
    }

    updateStatusPopup = async (id) => {
        const endpoint = `${apiUrl_popups}/${id}/status/`;
        const response = await this.patch(endpoint);
        return response;
    }

    deletePopup = async (id) => {
        const endpoint = `${apiUrl_popups}/${id}/deleted`;
        const response = await this.patch(endpoint);
        return response;
    }

}

const PopupService = new Service();

export default PopupService;
